export function isValidMoneyValue(str: string): boolean {
  const regex = /^[-]?\d+(?:\.\d{1,2})?$/;
  return regex.test(str);
}

export function isValidPositiveMoneyValue(moneyValue: string): boolean {
  const regex = /^(?!0)([1-9]\d*(\.\d{1,2})?)$/;
  return regex.test(String(moneyValue));
}

export function isValidPositiveWholeNumber(str: string): boolean {
  const regex = /^(?!0)([1-9]\d*)$/;
  return regex.test(str);
}
